import { Component, OnInit, OnDestroy } from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {CustomValidators} from 'ng2-validation';
import {Router} from '@angular/router';
import {Subscription} from 'rxjs/Subscription';
import {FooterNavbarService} from 'services/connectors/footer-navbar.service';
import {EmissionService} from 'services/emission.service';
import {Constants} from 'config/constants';
import {SpinnerService} from 'services/spinner.service';

@Component({
  selector: 'tpc-air-travel-employee',
  templateUrl: './air-travel-employee.component.html',
  styleUrls: ['./air-travel-employee.component.css']
})
export class AirTravelEmployeeComponent implements OnInit, OnDestroy {
    private nextSub: Subscription;
    private isFormSubmited = false;
    private countDefaultValue = 0;

    private _form: FormGroup;

    constructor(private emissionService: EmissionService,
                private footerService: FooterNavbarService,
                private router: Router,
                private fb: FormBuilder,
                private spinner: SpinnerService
    ) {
        this.nextSub = footerService.next$.subscribe(() => {
            this.isFormSubmited = true;
            if (this.form.status === 'VALID') {
                this.next();
            }
        });
        this.createForm();
    }

    ngOnInit() {
    }

    get form(): FormGroup {
        return this._form;
    }

    private createForm() {
        this._form = this.fb.group({
            employees: ['1', [
                Validators.required,
                CustomValidators.min(1),
                CustomValidators.max(99999),
                CustomValidators.digits]],
            countShort: [this.countDefaultValue, [
                Validators.required,
                CustomValidators.min(0),
                CustomValidators.max(999),
                CustomValidators.digits]],
            countMed: [this.countDefaultValue, [
                Validators.required,
                CustomValidators.min(0),
                CustomValidators.max(999),
                CustomValidators.digits]],
            countLong: [this.countDefaultValue, [
                Validators.required,
                CustomValidators.min(0),
                CustomValidators.max(999),
                CustomValidators.digits]],
        });
    }

    checkError(param) {
        return this.form.get(param).status === 'INVALID' && (this.isFormSubmited || this.form.get(param).touched);
    }

    next() {
        let calculatorName = Constants.calculators.business;
        let categoryName = 'airTravel';
        let params = {
            calculateBy: 'flights',
            employees: this.getFV('employees'),
            countShort: this.getFV('countShort'),
            countMed: this.getFV('countMed'),
            countLong: this.getFV('countLong')
        };

        if (!!params.employees && (!!params.countShort || !!params.countMed || !!params.countLong)) {
            this.spinner.show();
            this.emissionService.getEmissionValue(params, calculatorName, categoryName).subscribe(
                response => {
                    let input = response.body[0].input[0];
                    this.emissionService.setEmission({
                        category: Constants.categories.business.travel,
                        emission: {
                            emission: input.emmission,
                            emissionTrees: input.emissionTrees,
                            DollarAmt: input.DollarAmt,
                            DollarAmtMonthly: input.DollarAmtMonthly
                        }
                    });

                    this.footerService.skip();
                    this.spinner.hide();
                }
            );
        } else {
            this.emissionService.setEmission({
                category: Constants.categories.business.travel,
                emission: {
                    emission: 0,
                    emissionTrees: 0,
                    DollarAmt: 0,
                    DollarAmtMonthly: 0
                }
            });

            this.footerService.skip();
        }
    }

    getFV(param) {
        return this.form.get(param).value;
    }

    ngOnDestroy () {
        if (this.nextSub) {
            this.nextSub.unsubscribe();
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/components/calculator/calculator-item/business-calculator/air-travel/air-travel-employee/air-travel-employee.component.ts